import Chart from "../components/chart/chart";
import Sales from "../components/sales/sales";
import Table from "../components/table/table";
import Project from "../components/project/project";
import Team from "../components/team/team";
function Crm(){
    return(
        <>
        <Chart/>
        <Sales/>
        <Table/>
        <Project/>
        <Team/>
        </>
    )
}
export default Crm